import { render, staticRenderFns } from "./ApexDataBarChartTwo.vue?vue&type=template&id=8bcf3b48&"
import script from "./ApexDataBarChartTwo.vue?vue&type=script&lang=js&"
export * from "./ApexDataBarChartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports